import React, { useEffect, useState } from "react";
import { motion, useInView } from "framer-motion";
import { iconOf } from "../lib/icons";
import api from "../lib/api";

function Counter({ value }) {
  const ref = React.useRef(null);
  const inView = useInView(ref, { once: true });
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const start = performance.now();
    const tick = (t) => {
      const p = Math.min((t - start) / 1200, 1);
      setN(Math.round(value * (1 - Math.pow(1 - p, 3))));
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }, [inView, value]);
  return <span ref={ref}>{n}</span>;
}

export default function StatsBar({ content }) {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/stats").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return null;
  const items = (content.stats || []).map((it, i) => ({
    icon: iconOf(it.icon),
    label: it.label,
    value: it.source && it.source !== "manual" ? (s[it.source] ?? 0) : Number(it.value) || 0,
    tid: it.source && it.source !== "manual" ? `stat-${it.source}` : `stat-manual-${i}`,
  }));
  if (items.length === 0) return null;
  return (
    <section data-testid="stats-bar" className="relative -mt-10 z-10 px-4 sm:px-8">
      <div className="max-w-6xl mx-auto theater-card rounded-2xl border border-[#F0E8DB]/30 flex flex-wrap justify-center divide-[#F0E8DB]/10">
        {items.map((it, i) => (
          <motion.div
            key={it.tid}
            data-testid={it.tid}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
            className="flex flex-col items-center text-center py-6 px-3 w-1/2 sm:w-1/3 lg:flex-1 lg:border-s lg:first:border-s-0 border-[#F0E8DB]/10"
          >
            <it.icon size={20} className="text-[#F0E8DB] mb-2" />
            <div className="text-3xl sm:text-4xl font-bold text-[#F0E8DB] font-serif-en"><Counter value={it.value} /></div>
            <div className="text-[#A89A88] text-xs sm:text-sm mt-1">{it.label}</div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
